import useSWR from "swr";

export const useNotification = () => {

    const fetchUrl = `${process.env.SERVER_ADRESS}/messages`;
    const fetcher = async () => {
        try {
            const raw = await fetch(fetchUrl);
            const data = await raw.json();
            if (data.result) {
                const unreadMessages = data.result.filter(message => message.read === false);
                return unreadMessages.length;
            } else {
                return 0
            }
        } catch (error) {
            console.error('An error occurred getting notifications:', error.message);
            return 0;
        }

    };

    // const { data, error } = useSWR("notifications", fetcher, { refreshInterval: 5000 });
    const { data, error } = useSWR("notifications", fetcher);

    return {
        unreadMessagesNumber: data,
        error
    }
}